import React from 'react';
import { Header } from './style';

interface ChatHeaderWrapperProps {
  isUser: boolean;
  header: React.ReactNode;
}

const ChatHeaderWrapper = function ({
  isUser,
  header,
}: ChatHeaderWrapperProps) {
  if (!isUser) {
    return null;
  }

  return (
    <Header
      role="banner"
      aria-label="Chat header"
      className="chat-header-wrapper"
    >
      {header}
    </Header>
  );
};

export default ChatHeaderWrapper;
